import { render, staticRenderFns } from "./rwd-list.vue?vue&type=template&id=33fbae7e&scoped=true&"
import script from "./rwd-list.vue?vue&type=script&lang=js&"
export * from "./rwd-list.vue?vue&type=script&lang=js&"
import style0 from "./rwd-list.vue?vue&type=style&index=0&id=33fbae7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbae7e",
  null
  
)

export default component.exports